export default __webpack_public_path__ + "static/media/chrome.1b32e344.svg";